import { Component } from '@angular/core';
import { ShopSettingsService } from '../../modules/general/services/shop-settings.service';


@Component({
  selector: 'app-logo',
  templateUrl: './app-logo.component.html',
  styleUrls: ['./app-logo.component.css'],
})
export class AppLogoComponent {

  constructor(
    private shopSettingsService: ShopSettingsService,
  ) { }


  get logoUrl(): string {
    const externalLogoUrl = this.shopSettingsService.logoUrl;
    if (externalLogoUrl) {
      return externalLogoUrl;
    }

    return 'static/images/logo.svg';
  }
}
